import ErrorPage from './ErrorPage';
import IndexPage from './IndexPage';
import IndexConfigurePage from './IndexConfigurePage';
import GenericPage from './GenericPage';
import TestPage from './TestPage';
import TestFormPage from './TestFormPage';
import TestForm2Page from './TestForm2Page';
import TestDataGrid from './TestDataGrid';
import SignInPage from './SignInPage';
import InstitutionDetailsFormPage from './InstitutionDetailsFormPage';
import SyncPage from './SyncPage';
import AnimalListPage from './AnimalListPage';
import AnimalDashboardPage from './AnimalDashboardPage';
import AnimalFormPage from './AnimalFormPage';
import ChangesPage from './ChangesPage';
import ChangeDetailsPage from './ChangeDetailsPage';
import ChangeResolvePage from './ChangeResolvePage';
import DiagnosticsPage from './DiagnosticsPage';
import AnimalRelationshipsForm from './AnimalRelationshipsForm';
import AnimalDeathDepartureFormPage from './AnimalDeathDepartureFormPage.js';
import UsersListPage from './UsersListPage';
import UserFormPage from './UserFormPage';
import UserDashboardPage from './UserDashboardPage';
import UserCreatePage from './UserCreatePage';
import ProfileChangePasswordPage from './ProfileChangePasswordPage.js';
import ProfilePage from './ProfilePage';
import AssessmentsListPage from './AssessmentsListPage.js';
import AssessmentsFormPage from './AssessmentsFormPage.js';
import AssessmentDashboardPage from './AssessmentDashboardPage.js';
import AssessmentSectionAFormPage from './AssessmentSectionAFormPage';
import AssessmentSectionASelectPage from './AssessmentSectionASelectPage';
import AssessmentSectionBFormPage from './AssessmentSectionBFormPage';
import AssessmentSectionBSelectPage from './AssessmentSectionBSelectPage';
import AssessmentSubmitPage from './AssessmentSubmitPage';
import AssessmentSectionCSelectPage from './AssessmentSectionCSelectPage';
import AssessmentSectionCFormPage from './AssessmentSectionCFormPage';
import AssessmentSectionCIncidentsOfAggressionListPage from './AssessmentSectionCIncidentsOfAggressionListPage';
import AssessmentSectionCIncidentsOfAggressionFormPage from './AssessmentSectionCIncidentsOfAggressionFormPage';
import AssessmentFinalEvaluationFormPage from './AssessmentFinalEvaluationFormPage';
import AssessmentTypesListPage from './AssessmentTypesListPage';
import AssessmentTypeFormPage from './AssessmentTypeFormPage';
import BehaviorTagSetsListPage from './BehaviorTagSetsListPage';
import BehaviorTagSetFormPage from './BehaviorTagSetFormPage';
import LocationsListPage from './LocationsListPage';
import LocationFormPage from './LocationFormPage';
import OtpPage from './OtpPage';
import ForgotPasswordPage from './ForgotPasswordPage';
import ManualPage from './ManualPage';
import MoreInfoPage from './MoreInfoPage';
import ReportingPage from './ReportingPage';
import AssessmentReportPage from './AssessmentReportPage.tsx';
import TimelinePage from './TimelinePage.tsx';
import AssessmentComparisonPage from './AssessmentComparisonPage.tsx';


const pages = {
    IndexPage,
    IndexConfigurePage,
    ErrorPage,
    GenericPage,
    SignInPage,
    OtpPage,
    ForgotPasswordPage,
    ManualPage,
    TestPage,
    TestFormPage,
    TestForm2Page,
    TestDataGrid,
    InstitutionDetailsFormPage,
    SyncPage,
    AnimalListPage,
    AnimalDashboardPage,
    AnimalFormPage,
    AnimalDeathDepartureFormPage,
    ChangesPage,
    ChangeDetailsPage,
    ChangeResolvePage,
    DiagnosticsPage,
    AnimalRelationshipsForm,
    UsersListPage,
    UserFormPage,
    UserDashboardPage,
    UserCreatePage,
    ProfileChangePasswordPage,
    ProfilePage,
    AssessmentsListPage,
    AssessmentsFormPage,
    AssessmentDashboardPage,
    AssessmentSectionBFormPage,
    AssessmentSectionBSelectPage,
    AssessmentSectionAFormPage,
    AssessmentSectionASelectPage,
    AssessmentSubmitPage,
    AssessmentSectionCSelectPage,
    AssessmentSectionCFormPage,
    AssessmentSectionCIncidentsOfAggressionListPage,
    AssessmentSectionCIncidentsOfAggressionFormPage,
    AssessmentFinalEvaluationFormPage,
    AssessmentTypesListPage,
    AssessmentTypeFormPage,
    BehaviorTagSetsListPage,
    BehaviorTagSetFormPage,
    LocationsListPage,
    LocationFormPage,
    MoreInfoPage,
    ReportingPage,
    AssessmentReportPage,
    TimelinePage,
    AssessmentComparisonPage,
};

export default pages;
